/**
 * Utility functions for region-specific logic
 */

/**
 * Determines if producer business data is required for a specific region
 * @param {string} region - The region code
 * @returns {boolean} - Whether producer business data is required
 */
export const requiresProducerBusinessData = (region) => {
    switch (region) {
        case 'BONGARDS':
        case 'UDI':
        case 'DEMO':
            return true;
        default:
            return false;
    }
};

/**
 * Determines if lab data is required for a specific region
 * @param {string} region - The region code
 * @returns {boolean} - Whether lab data is required
 */
export const requiresLabData = (region) => {
    switch (region) {
        case 'CDI':
        case 'PRAIRIE':
            return false;
        default:
            return true;
    }
};

/**
 * Determines if route sessions need to be fetched before pickups for a specific region
 * @param {string} region - The region code
 * @returns {boolean} - Whether route sessions should be fetched first
 */
export const requiresRouteSessionsBeforePickups = (region) => {
    switch (region) {
        // case 'NL':
        //     return true;
        default:
            return false;
    }
};
